import React, { Component } from "react";
import styled from "styled-components";
import tramData from "../../assets/data/manchester.json";

const d3 = require('d3');
const tubeMap = require('../../assets/libs/altered-d3-tube-map');

const MapBlock = styled.div`

    div#tube-map {
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
`

export default class Map extends Component {

    componentDidMount() {
        this.setStationAlerts(tramData)
    }

    setStationAlerts(tramData) {

        fetch("/updates")
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(travelUpdates => {
            travelUpdates.forEach(element => {
                var formattedStopName =  element.replace('tram stop', '')
                formattedStopName = formattedStopName.replaceAll(' ', '');


                if (tramData.stations.hasOwnProperty(formattedStopName)) {
                    tramData.stations[formattedStopName].alerts = true;
                } else {
                    console.error(`Station "${formattedStopName}" not found in tramData.stations.`);
                }
            })

            d3.tubeMap = tubeMap.tubeMap;
            d3.select('#tube-map').html(null);

            this.renderMap(this.props);

        })
        .catch((error) => {
            console.error("Error fetching travel update content: ", error);
        });
    }

    renderMap(props) {
        var container = d3.select("#tube-map")
            .on("click", () => props.openNavbar(false));
        var width = 1600;
        var height = 1000;
        var viewportWidth = container.node().clientWidth;
        var viewportHeight = container.node().clientHeight;

        var map = d3
            .tubeMap()
            .width(width)
            .height(height)
            .margin({
                top: 20,
                right: 20,
                bottom: 40,
                left: 100,
            })
            .on("click", function (tramStop) {
                props.selectTramStop(tramStop)
              });

        container
            .datum(tramData).call(map);

        var _data = map.data();

        window.mapData = {
            lines: _data.lines,
            stations: _data.stations
        }

        map.drawAll()

        if (props.onMapReady) {
            props.onMapReady(map);
        }

        var svg = container.select('svg');
        var bbox = svg.select('g').node().getBBox();

        var zoom = d3
          .zoom()
          .extent([[0, 0], [viewportWidth, viewportHeight]])
          .scaleExtent([0.7, 6])
          .on('zoom', zoomed);

        var zoomContainer = svg.call(zoom);

        zoom.scaleTo(zoomContainer, 1.5);
        zoom.translateTo(zoomContainer, bbox.x + bbox.width / 2, bbox.y + bbox.height / 2);


        function zoomed() {
            svg.select('g').attr('transform', d3.event.transform.toString());
        }

        this.prefetchImages();
    }

    prefetchImages() {
        const names = Object.keys(tramData.stations).filter((key) => !/\s\d+$/.test(key));

        names.forEach((name, index) => {
            setTimeout(() => {
                const img = new Image();
                img.src = `/assets/images/${name}.avif`;
            }, index * 30);
        });
    }

    render() {
        return (
            <MapBlock>
                <div id="tube-map"></div>
            </MapBlock>
        )
    }
};
